(function() {
  /* ========== CALCULATOR ========== */
  var factors = {
    sedentary:  { maintain: 0.8, lose: 1.0, muscle: 1.2 },
    moderate:   { maintain: 1.0, lose: 1.2, muscle: 1.5 },
    active:     { maintain: 1.2, lose: 1.5, muscle: 1.8 },
    sport:      { maintain: 1.5, lose: 1.8, muscle: 2.0 }
  };

  var weightSlider = document.getElementById('protWeight');
  if (!weightSlider) return;

  /* ========== LANGUE ET TEXTES ========== */
  var lang = (document.documentElement.lang || 'fr').split('-')[0].toLowerCase();
  var TEXTS = {
    fr: {
      range: '{a} à {b} g',
      activity: { sedentary: 'Sédentaire', moderate: 'Modéré', active: 'Actif', sport: 'Sportif' },
      goal: { maintain: 'Maintien', lose: 'Perte de poids', muscle: 'Muscle' },
      empty: 'Aucun produit trouvé pour cette combinaison. Essayez une autre sélection.',
      loading: 'Chargement des produits…',
      error: 'Impossible de charger les produits. Veuillez réessayer.',
      discover: 'Découvrir',
      protein: '{n} g de protéines',
      note: 'Repère indicatif, calculé à partir de votre poids, de votre activité et de votre objectif : de 0,8 à 2 g de protéines par kilo de poids corporel et par jour. Valeur de référence pour un adulte en bonne santé : 0,83 g/kg par jour (EFSA, 2012). Ce repère ne remplace pas l\'avis d\'un professionnel de santé.',
      toggle: 'Recevoir mon résultat et un menu type par e-mail',
      email: 'Votre adresse e-mail',
      consent: 'J\'accepte que Mincidélice enregistre mon adresse e-mail, mon repère de protéines arrondi, mon niveau d\'activité et mon objectif, pour m\'envoyer mon résultat, un menu type et des conseils par e-mail. Mon poids n\'est pas enregistré. Désinscription en un clic dans chaque e-mail.',
      privacy: 'Politique de confidentialité',
      submit: 'Recevoir par e-mail',
      errEmail: 'Indiquez une adresse e-mail valide.',
      errOptin: 'Cochez la case pour recevoir votre résultat par e-mail.',
      errSend: 'L\'envoi n\'a pas abouti. Réessayez dans un instant.',
      done: 'C\'est noté. Votre résultat et votre menu type arrivent par e-mail.'
    },
    it: {
      range: 'da {a} a {b} g',
      activity: { sedentary: 'Sedentario', moderate: 'Moderato', active: 'Attivo', sport: 'Sportivo' },
      goal: { maintain: 'Mantenimento', lose: 'Perdita di peso', muscle: 'Muscolo' },
      empty: 'Nessun prodotto trovato per questa combinazione. Prova un\'altra selezione.',
      loading: 'Caricamento dei prodotti…',
      error: 'Impossibile caricare i prodotti. Riprova.',
      discover: 'Scopri',
      protein: '{n} g di proteine',
      note: 'Valore indicativo, calcolato in base al tuo peso, alla tua attività e al tuo obiettivo: da 0,8 a 2 g di proteine per chilo di peso corporeo al giorno. Valore di riferimento per un adulto in buona salute: 0,83 g/kg al giorno (EFSA, 2012). Non sostituisce il parere di un professionista della salute.',
      toggle: 'Ricevi il tuo risultato e un menu tipo via e-mail',
      email: 'Il tuo indirizzo e-mail',
      consent: 'Accetto che Mincidélice registri il mio indirizzo e-mail, il mio fabbisogno proteico arrotondato, il mio livello di attività e il mio obiettivo, per inviarmi il risultato, un menu tipo e dei consigli via e-mail. Il mio peso non viene registrato. Posso annullare l\'iscrizione con un clic da ogni e-mail.',
      privacy: 'Informativa sulla privacy',
      submit: 'Ricevi via e-mail',
      errEmail: 'Inserisci un indirizzo e-mail valido.',
      errOptin: 'Spunta la casella per ricevere il risultato via e-mail.',
      errSend: 'Invio non riuscito. Riprova tra un istante.',
      done: 'Fatto. Il tuo risultato e il tuo menu tipo arrivano via e-mail.'
    },
    es: {
      range: 'de {a} a {b} g',
      activity: { sedentary: 'Sedentario', moderate: 'Moderado', active: 'Activo', sport: 'Deportista' },
      goal: { maintain: 'Mantenimiento', lose: 'Pérdida de peso', muscle: 'Músculo' },
      empty: 'No hay productos para esta combinación. Prueba otra selección.',
      loading: 'Cargando productos…',
      error: 'No se han podido cargar los productos. Inténtalo de nuevo.',
      discover: 'Descubrir',
      protein: '{n} g de proteínas',
      note: 'Valor orientativo, calculado a partir de tu peso, tu actividad y tu objetivo: de 0,8 a 2 g de proteínas por kilo de peso corporal y día. Valor de referencia para un adulto sano: 0,83 g/kg al día (EFSA, 2012). No sustituye el consejo de un profesional de la salud.',
      toggle: 'Recibir mi resultado y un menú tipo por correo electrónico',
      email: 'Tu correo electrónico',
      consent: 'Acepto que Mincidélice guarde mi correo electrónico, mi necesidad de proteínas redondeada, mi nivel de actividad y mi objetivo, para enviarme mi resultado, un menú tipo y consejos por correo electrónico. Mi peso no se guarda. Puedo darme de baja con un clic desde cada correo.',
      privacy: 'Política de privacidad',
      submit: 'Recibir por correo',
      errEmail: 'Introduce un correo electrónico válido.',
      errOptin: 'Marca la casilla para recibir tu resultado por correo.',
      errSend: 'El envío no se ha completado. Inténtalo de nuevo en un momento.',
      done: 'Listo. Tu resultado y tu menú tipo llegan por correo electrónico.'
    },
    de: {
      range: '{a} bis {b} g',
      activity: { sedentary: 'Sitzend', moderate: 'Moderat', active: 'Aktiv', sport: 'Sportlich' },
      goal: { maintain: 'Halten', lose: 'Abnehmen', muscle: 'Muskelaufbau' },
      empty: 'Keine Produkte für diese Kombination gefunden. Probiere eine andere Auswahl.',
      loading: 'Produkte werden geladen…',
      error: 'Die Produkte konnten nicht geladen werden. Bitte versuche es erneut.',
      discover: 'Entdecken',
      protein: '{n} g Protein',
      note: 'Orientierungswert, berechnet aus deinem Gewicht, deiner Aktivität und deinem Ziel: 0,8 bis 2 g Protein pro Kilogramm Körpergewicht und Tag. Referenzwert für gesunde Erwachsene: 0,83 g/kg pro Tag (EFSA, 2012). Er ersetzt nicht den Rat einer medizinischen Fachkraft.',
      toggle: 'Mein Ergebnis und einen Beispiel-Speiseplan per E-Mail erhalten',
      email: 'Deine E-Mail-Adresse',
      consent: 'Ich bin einverstanden, dass Mincidélice meine E-Mail-Adresse, meinen gerundeten Proteinbedarf, mein Aktivitätsniveau und mein Ziel speichert, um mir mein Ergebnis, einen Beispiel-Speiseplan und Tipps per E-Mail zu senden. Mein Gewicht wird nicht gespeichert. Abmeldung mit einem Klick in jeder E-Mail.',
      privacy: 'Datenschutzerklärung',
      submit: 'Per E-Mail erhalten',
      errEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      errOptin: 'Bitte setze das Häkchen, um dein Ergebnis per E-Mail zu erhalten.',
      errSend: 'Der Versand hat nicht geklappt. Bitte versuche es gleich noch einmal.',
      done: 'Erledigt. Dein Ergebnis und dein Beispiel-Speiseplan kommen per E-Mail.'
    },
    pl: {
      range: 'od {a} do {b} g',
      activity: { sedentary: 'Siedzący', moderate: 'Umiarkowany', active: 'Aktywny', sport: 'Sportowy' },
      goal: { maintain: 'Utrzymanie', lose: 'Utrata wagi', muscle: 'Mięśnie' },
      empty: 'Brak produktów dla tego wyboru. Wybierz inną kombinację.',
      loading: 'Ładowanie produktów…',
      error: 'Nie udało się załadować produktów. Spróbuj ponownie.',
      discover: 'Zobacz',
      protein: '{n} g białka',
      note: 'Wartość orientacyjna, obliczona na podstawie Twojej masy ciała, aktywności i celu: od 0,8 do 2 g białka na kilogram masy ciała dziennie. Wartość referencyjna dla zdrowej osoby dorosłej: 0,83 g/kg dziennie (EFSA, 2012). Nie zastępuje porady lekarza ani dietetyka.',
      toggle: 'Otrzymaj swój wynik i przykładowy jadłospis e-mailem',
      email: 'Twój adres e-mail',
      consent: 'Zgadzam się, aby firma Mincidélice zapisała mój adres e-mail, moje zaokrąglone zapotrzebowanie na białko, poziom aktywności i cel, aby wysłać mi wynik, przykładowy jadłospis i porady e-mailem. Moja masa ciała nie jest zapisywana. Mogę wypisać się jednym kliknięciem w każdej wiadomości.',
      privacy: 'Polityka prywatności',
      submit: 'Wyślij na e-mail',
      errEmail: 'Podaj poprawny adres e-mail.',
      errOptin: 'Zaznacz pole, aby otrzymać wynik e-mailem.',
      errSend: 'Wysyłka się nie powiodła. Spróbuj ponownie za chwilę.',
      done: 'Gotowe. Twój wynik i przykładowy jadłospis dotrą e-mailem.'
    },
    pt: {
      range: 'de {a} a {b} g',
      activity: { sedentary: 'Sedentário', moderate: 'Moderado', active: 'Ativo', sport: 'Desportista' },
      goal: { maintain: 'Manutenção', lose: 'Perda de peso', muscle: 'Músculo' },
      empty: 'Nenhum produto encontrado para esta combinação. Experimenta outra seleção.',
      loading: 'A carregar os produtos…',
      error: 'Não foi possível carregar os produtos. Tenta novamente.',
      discover: 'Descobrir',
      protein: '{n} g de proteínas',
      note: 'Valor indicativo, calculado a partir do teu peso, da tua atividade e do teu objetivo: de 0,8 a 2 g de proteínas por quilo de peso corporal e por dia. Valor de referência para um adulto saudável: 0,83 g/kg por dia (EFSA, 2012). Não substitui o aconselhamento de um profissional de saúde.',
      toggle: 'Receber o meu resultado e um menu tipo por e-mail',
      email: 'O teu endereço de e-mail',
      consent: 'Aceito que a Mincidélice guarde o meu endereço de e-mail, a minha necessidade de proteínas arredondada, o meu nível de atividade e o meu objetivo, para me enviar o meu resultado, um menu tipo e conselhos por e-mail. O meu peso não é guardado. Posso cancelar a subscrição com um clique em cada e-mail.',
      privacy: 'Política de privacidade',
      submit: 'Receber por e-mail',
      errEmail: 'Indica um endereço de e-mail válido.',
      errOptin: 'Assinala a caixa para receberes o teu resultado por e-mail.',
      errSend: 'O envio não foi concluído. Tenta novamente dentro de instantes.',
      done: 'Feito. O teu resultado e o teu menu tipo chegam por e-mail.'
    }
  };
  var T = TEXTS[lang] || TEXTS.fr;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var weightDisplay = document.getElementById('protWeightDisplay');
  var activityGroup = document.getElementById('protActivity');
  var goalGroup = document.getElementById('protGoal');
  var resultBox = document.getElementById('protResult');
  var gramsEl = document.getElementById('protGrams');
  var portionsEl = document.getElementById('protPortions');
  var barEl = document.getElementById('protBar');

  // Dernier calcul affiche : seules ces trois valeurs sortent de la page (jamais le poids)
  var current = { tranche: 0, activity: 'moderate', goal: 'lose' };

  /* ========== MESURE : un evenement dataLayer par calcul termine ========== */
  var measureTimer = null;
  var measureTouched = false;
  var measureLast = null;

  function flushMeasure() {
    if (measureTimer) { clearTimeout(measureTimer); measureTimer = null; }
    if (!measureTouched) return;
    var sig = current.tranche + '|' + current.activity + '|' + current.goal;
    if (sig === measureLast) return;
    measureLast = sig;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'calcul_proteines',
        prot_tranche: current.tranche,
        prot_activite: current.activity,
        prot_objectif: current.goal,
        prot_langue: lang
      });
    } catch (e) {}
  }

  // Appele a chaque reglage du visiteur : l'evenement part quand il a fini (1,5 s sans action)
  function scheduleMeasure() {
    measureTouched = true;
    if (measureTimer) clearTimeout(measureTimer);
    measureTimer = setTimeout(flushMeasure, 1500);
  }

  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden' && measureTimer) flushMeasure();
  });

  function getSelected(groupEl) {
    var active = groupEl.querySelector('.active');
    return active ? active.getAttribute('data-val') : null;
  }

  function setupToggle(groupEl, onChange) {
    var btns = groupEl.querySelectorAll('button');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        btns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        onChange(btn.getAttribute('data-val'));
      });
    });
  }

  function animateNumber(el, target) {
    var from = parseInt(el.textContent) || 0;
    var diff = target - from;
    if (diff === 0) return;
    var steps = 20;
    var stepVal = diff / steps;
    var i = 0;
    var interval = setInterval(function() {
      i++;
      if (i >= steps) {
        el.textContent = target;
        clearInterval(interval);
      } else {
        el.textContent = Math.round(from + stepVal * i);
      }
    }, 25);
  }

  function calculate() {
    var weight = parseInt(weightSlider.value);
    var activity = getSelected(activityGroup) || 'moderate';
    var goal = getSelected(goalGroup) || 'lose';
    var factor = factors[activity][goal];
    var grams = Math.round(weight * factor);
    var portions = Math.round(grams / 15);
    // Tranche : dizaine la plus proche, bornee de 40 a 200 g par jour
    current.tranche = Math.min(200, Math.max(40, Math.round(grams / 10) * 10));
    current.activity = activity;
    current.goal = goal;

    animateNumber(gramsEl, grams);
    animateNumber(portionsEl, portions);

    // Bar: map grams to 0-100%, max at 200g
    var pct = Math.min(Math.max((grams / 200) * 100, 5), 100);
    barEl.style.width = pct + '%';

    // Color
    if (pct < 30) barEl.style.background = '#EF4444';
    else if (pct < 50) barEl.style.background = '#ff9200';
    else if (pct < 75) barEl.style.background = '#10B981';
    else barEl.style.background = '#ff9200';

    resultBox.classList.add('visible');
  }

  weightSlider.addEventListener('input', function() {
    weightDisplay.textContent = weightSlider.value;
    calculate();
    scheduleMeasure();
  });

  setupToggle(activityGroup, function() { calculate(); scheduleMeasure(); });
  setupToggle(goalGroup, function() { calculate(); scheduleMeasure(); });

  // Initial calc
  calculate();

  // Smooth scroll
  document.getElementById('protScrollLink').addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('prot-recommender').scrollIntoView({ behavior: 'smooth' });
  });

  /* ========== PRODUCT RECOMMENDER ========== */
  var momentFlavorMap = {
    'breakfast-sweet': ['cereales-muesli', 'boissons-en-poudre', 'cremes-entremets-a-preparer', 'cakes-pancakes', 'pates-a-tartiner'],
    'breakfast-salty':  ['pains-biscottes', 'omelettes-galettes'],
    'meal-sweet':      ['substituts-de-repas', 'cremes-entremets-a-preparer', 'boissons-en-poudre'],
    'meal-salty':      ['plats-cuisines', 'plats-a-cuisiner', 'soupes-veloutes', 'omelettes-galettes', 'pates'],
    'snack-sweet':     ['barres-croustillantes', 'gateaux', 'gaufrettes', 'chocolats-bonbons', 'cremes-desserts-prets-a-lemploi'],
    'snack-salty':     ['chips-aperitifs', 'pains-biscottes', 'pains-pizza']
  };

  var dietCollections = {
    'gluten-free':  'sans-gluten',
    'vegan':        'programme-minceur-vegan',
    'lactose-free': 'sans-lactose',
    'keto':         'keto'
  };

  var pickedMoment = null;
  var pickedFlavor = null;
  var pickedDiets = [];
  var productsArea = document.getElementById('protProductsArea');

  function setupSinglePicker(groupId, callback) {
    var group = document.getElementById(groupId);
    var btns = group.querySelectorAll('button');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        btns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        callback(btn.getAttribute('data-val'));
      });
    });
  }

  // Multi-select for diets (toggle on/off)
  function setupMultiPicker(groupId, callback) {
    var group = document.getElementById(groupId);
    var btns = group.querySelectorAll('button');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        btn.classList.toggle('active');
        var selected = [];
        btns.forEach(function(b) {
          if (b.classList.contains('active')) selected.push(b.getAttribute('data-val'));
        });
        callback(selected);
      });
    });
  }

  setupSinglePicker('protMoment', function(val) {
    pickedMoment = val;
    maybeLoadProducts();
  });

  setupSinglePicker('protFlavor', function(val) {
    pickedFlavor = val;
    maybeLoadProducts();
  });

  setupMultiPicker('protDiet', function(vals) {
    pickedDiets = vals;
    maybeLoadProducts();
  });

  function maybeLoadProducts() {
    if (!pickedMoment || !pickedFlavor) return;
    var key = pickedMoment + '-' + pickedFlavor;
    var collections = momentFlavorMap[key];
    if (!collections) return;

    if (pickedDiets.length > 0) {
      // Add diet-specific collections and use them to cross-filter
      loadProductsWithDietFilter(collections, pickedDiets);
    } else {
      loadProducts(collections);
    }
  }

  async function fetchProducts(collections) {
    var all = [];
    for (var i = 0; i < collections.length; i++) {
      try {
        var res = await fetch(root + 'collections/' + collections[i] + '/products.json?limit=8');
        var data = await res.json();
        if (data.products) {
          all = all.concat(data.products);
        }
      } catch(e) {}
    }
    // Deduplicate by id
    var seen = {};
    var unique = [];
    for (var j = 0; j < all.length; j++) {
      if (!seen[all[j].id]) {
        seen[all[j].id] = true;
        unique.push(all[j]);
      }
    }
    // Shuffle and take 8
    for (var k = unique.length - 1; k > 0; k--) {
      var r = Math.floor(Math.random() * (k + 1));
      var tmp = unique[k];
      unique[k] = unique[r];
      unique[r] = tmp;
    }
    return unique.slice(0, 8);
  }

  function getProteinFromTags(tags) {
    if (!tags) return null;
    var tagList = typeof tags === 'string' ? tags.split(',') : tags;
    for (var i = 0; i < tagList.length; i++) {
      var t = tagList[i].trim().toLowerCase();
      var match = t.match(/prot[eéè]ines?\s*[:=]?\s*(\d+)/);
      if (match) return match[1];
    }
    return null;
  }

  // Les prix de products.json sont en euros : on ne les affiche que si la boutique est en euros
  function formatPrice(price) {
    var num = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(num)) return '';
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (active && active !== 'EUR') return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: 'EUR' }).format(num);
    } catch (e) {
      return num.toFixed(2).replace('.', ',') + ' \u20AC';
    }
  }

  function renderProducts(products) {
    if (!products.length) {
      productsArea.innerHTML = '<div class="prot-empty">' + esc(T.empty) + '</div>';
      return;
    }
    var html = '<div class="prot-products-grid">';
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var imgSrc = (p.images && p.images.length) ? p.images[0].src : '';
      if (imgSrc) {
        // Resize to 300px via Shopify CDN
        imgSrc = imgSrc.replace(/(\.\w+)(\?|$)/, '_300x$1$2');
      }
      var price = (p.variants && p.variants.length) ? formatPrice(p.variants[0].price) : '';
      var protein = getProteinFromTags(p.tags);

      html += '<div class="prot-product-card">';
      if (imgSrc) html += '<img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy">';
      html += '<div class="info">';
      html += '<h4>' + esc(p.title) + '</h4>';
      if (price) html += '<div class="price">' + esc(price) + '</div>';
      if (protein) html += '<span class="prot-tag">' + esc(T.protein.replace('{n}', protein)) + '</span>';
      html += '<a class="btn-discover" href="' + esc(root + 'products/' + p.handle) + '">' + esc(T.discover) + '</a>';
      html += '</div></div>';
    }
    html += '</div>';
    productsArea.innerHTML = html;
  }

  async function loadProductsWithDietFilter(baseCollections, diets) {
    productsArea.innerHTML = '<div class="prot-loading"><div class="spinner"></div><div>' + esc(T.loading) + '</div></div>';
    try {
      // Fetch from base collections
      var baseProducts = await fetchProducts(baseCollections);
      // Fetch from diet collections
      var dietProductIds = {};
      for (var d = 0; d < diets.length; d++) {
        var dietHandle = dietCollections[diets[d]];
        if (!dietHandle) continue;
        try {
          var res = await fetch(root + 'collections/' + dietHandle + '/products.json?limit=250');
          var data = await res.json();
          if (data.products) {
            data.products.forEach(function(p) { dietProductIds[p.id] = true; });
          }
        } catch(e) {}
      }
      // Cross-filter: keep only base products that are also in diet collections
      var filtered = baseProducts.filter(function(p) { return dietProductIds[p.id]; });
      if (filtered.length === 0) {
        // Fallback: show diet collection products directly
        var dietHandles = diets.map(function(d) { return dietCollections[d]; }).filter(Boolean);
        filtered = await fetchProducts(dietHandles);
      }
      renderProducts(filtered);
    } catch(e) {
      productsArea.innerHTML = '<div class="prot-empty">' + esc(T.error) + '</div>';
    }
  }

  async function loadProducts(collections) {
    productsArea.innerHTML = '<div class="prot-loading"><div class="spinner"></div><div>' + esc(T.loading) + '</div></div>';
    try {
      var products = await fetchProducts(collections);
      renderProducts(products);
    } catch(e) {
      productsArea.innerHTML = '<div class="prot-empty">' + esc(T.error) + '</div>';
    }
  }

  /* ========== REPERE ET CAPTURE D'E-MAIL FACULTATIVE ========== */
  // Le resultat reste visible sans rien donner. Klaviyo ne recoit que l'e-mail, la tranche,
  // l'activite, l'objectif, la langue et la collection conseillee : jamais le poids.
  var KLAVIYO_COMPANY = 'YkVdb9';
  var KLAVIYO_LIST = 'Xmx5Lp';

  function recommendedCollection() {
    var list = (pickedMoment && pickedFlavor) ? momentFlavorMap[pickedMoment + '-' + pickedFlavor] : null;
    return '/collections/' + ((list && list[0]) || 'aliments-proteines');
  }

  (function setupLead() {
    if (!resultBox || !resultBox.parentNode) return;

    var css = ''
      + '#protLead{margin:0 0 16px;text-align:center}'
      + '#protLead [hidden]{display:none!important}'
      + '#protLead .prot-lead-note{font-size:.8rem;line-height:1.5;color:#4B5563;max-width:640px;margin:0 auto 14px}'
      + '#protLead .prot-lead-toggle{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:10px 18px;border:2px solid #E5E7EB;border-radius:12px;background:#fff;color:#111;font:inherit;font-size:.95rem;font-weight:600;line-height:1.3;letter-spacing:normal;text-transform:none;cursor:pointer;transition:border-color .2s}'
      + '#protLead .prot-lead-toggle:hover{border-color:#ff9200}'
      + '#protLead .prot-lead-toggle:disabled{border-color:#E5E7EB;color:#4B5563;cursor:default}'
      + '#protLead .prot-lead-form{text-align:left;background:#fff;border:1px solid #E5E7EB;border-radius:16px;padding:20px;max-width:520px;margin:12px auto 0;box-shadow:0 1px 3px rgba(0,0,0,.06)}'
      + '#protLead .prot-lead-label{display:block;font-weight:600;font-size:.95rem;line-height:1.4;letter-spacing:normal;text-transform:none;color:#111;margin-bottom:8px}'
      + '#protLead .prot-lead-email{display:block;width:100%;min-height:48px;padding:10px 14px;border:2px solid #D1D5DB;border-radius:12px;background:#fff;color:#111;font:inherit;font-size:16px;letter-spacing:normal}'
      + '#protLead .prot-lead-consent{display:flex;align-items:flex-start;gap:10px;margin-top:14px;font-size:.82rem;font-weight:400;line-height:1.5;letter-spacing:normal;text-transform:none;color:#374151;cursor:pointer}'
      + '#protLead .prot-lead-consent input{flex:0 0 auto;width:22px;height:22px;margin-top:1px;accent-color:#ff9200;cursor:pointer}'
      + '#protLead .prot-lead-consent a{color:#111;text-decoration:underline}'
      + '#protLead .prot-lead-msg{font-size:.85rem;font-weight:600;color:#B91C1C;margin-top:10px}'
      + '#protLead .prot-lead-msg:empty{display:none}'
      + '#protLead .prot-lead-submit{display:block;width:100%;min-height:48px;margin-top:14px;padding:10px 18px;border:0;border-radius:12px;background:#111;color:#fff;font:inherit;font-size:1rem;font-weight:700;letter-spacing:normal;text-transform:none;cursor:pointer}'
      + '#protLead .prot-lead-submit:disabled{opacity:.6;cursor:default}'
      + '#protLead .prot-lead-done{margin-top:14px;padding:14px 16px;border:1px solid #BBF7D0;border-radius:12px;background:#F0FDF4;color:#111;font-size:.95rem;font-weight:600}'
      + '#protLead .prot-lead-toggle:focus-visible,#protLead .prot-lead-email:focus-visible,#protLead .prot-lead-consent input:focus-visible,#protLead .prot-lead-submit:focus-visible{outline:3px solid #ff9200;outline-offset:2px}'
      + '#protLead .prot-lead-email:focus-visible{border-color:#111}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var html = '<p class="prot-lead-note">' + esc(T.note) + '</p>';
    var capture = window.MinciProtLead !== false;
    if (capture) {
      html += '<button type="button" class="prot-lead-toggle" id="protLeadToggle" aria-expanded="false" aria-controls="protLeadForm">' + esc(T.toggle) + '</button>'
        + '<form class="prot-lead-form" id="protLeadForm" novalidate hidden>'
        + '<label class="prot-lead-label" for="protLeadEmail">' + esc(T.email) + '</label>'
        + '<input class="prot-lead-email" type="email" id="protLeadEmail" name="email" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" required aria-describedby="protLeadMsg">'
        + '<label class="prot-lead-consent"><input type="checkbox" id="protLeadOptin" aria-describedby="protLeadMsg">'
        + '<span>' + esc(T.consent) + ' <a href="' + esc(root + 'policies/privacy-policy') + '" target="_blank" rel="noopener">' + esc(T.privacy) + '</a></span></label>'
        + '<p class="prot-lead-msg" id="protLeadMsg" role="alert"></p>'
        + '<button type="submit" class="prot-lead-submit">' + esc(T.submit) + '</button>'
        + '<p class="prot-lead-done" id="protLeadDone" role="status" tabindex="-1" hidden>' + esc(T.done) + '</p>'
        + '</form>';
    }
    var box = document.createElement('div');
    box.id = 'protLead';
    box.innerHTML = html;
    resultBox.insertAdjacentElement('afterend', box);
    if (!capture) return;

    var toggle = document.getElementById('protLeadToggle');
    var form = document.getElementById('protLeadForm');
    var emailInput = document.getElementById('protLeadEmail');
    var optin = document.getElementById('protLeadOptin');
    var msg = document.getElementById('protLeadMsg');
    var done = document.getElementById('protLeadDone');
    var submitBtn = form.querySelector('.prot-lead-submit');
    var sending = false;

    toggle.addEventListener('click', function() {
      var open = form.hidden;
      form.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) emailInput.focus();
    });

    function fail(text, field) {
      msg.textContent = text;
      if (field === emailInput) emailInput.setAttribute('aria-invalid', 'true');
      else emailInput.removeAttribute('aria-invalid');
      if (field) field.focus();
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (sending) return;
      var email = emailInput.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return fail(T.errEmail, emailInput);
      if (!optin.checked) return fail(T.errOptin, optin);
      msg.textContent = '';
      emailInput.removeAttribute('aria-invalid');
      // Envoyer son e-mail vaut calcul termine, meme sans avoir touche aux reglages
      measureTouched = true;
      flushMeasure();

      // Libelle du choix : dictionnaire (memes mots que la page, avec les accents) ; a defaut, texte du bouton
      function shownLabel(groupEl, dict, val) {
        var btn = groupEl.querySelector('button[data-val="' + val + '"]');
        var text = btn ? btn.textContent.replace(/\s+/g, ' ').trim() : '';
        return dict[val] || text;
      }
      var low = Math.max(30, current.tranche - 10);
      var range = T.range.replace('{a}', low).replace('{b}', current.tranche + 10);
      var product = recommendedCollection();
      var now = new Date();
      var profileData = {
        'Proteines_besoin_tranche': range,
        'Proteines_activite': current.activity,
        'Proteines_objectif': current.goal,
        'Proteines_produit_recommande': product,
        'Proteines_date': now.toISOString().split('T')[0],
        'Proteines_accord_le': now.toISOString(),
        'Language': lang
      };
      // Noms attendus par les modeles d'e-mail (KLAVIYO_PROPRIETES_UTILISEES.md)
      var eventData = {
        'Language': lang,
        'Besoin_tranche': range,
        'Besoin_tranche_g': current.tranche,
        'Activite': current.activity,
        'Activite_libelle': shownLabel(activityGroup, T.activity, current.activity),
        'Objectif': current.goal,
        'Objectif_libelle': shownLabel(goalGroup, T.goal, current.goal),
        'Produit_recommande': product
      };

      sending = true;
      submitBtn.disabled = true;
      var endpoint = 'https://a.klaviyo.com/client/';
      var key = '/?company_id=' + KLAVIYO_COMPANY;
      var options = function(data) {
        return { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' }, body: JSON.stringify({ data: data }) };
      };
      var checked = function(r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); };
      // 1. Abonnement e-mail explicite (case cochee) ; Klaviyo horodate l'accord a la reception
      fetch(endpoint + 'subscriptions' + key, options({
        type: 'subscription',
        attributes: {
          custom_source: 'Calculateur Proteines',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                properties: profileData
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
      })).then(checked).then(function() {
        // 2. Evenement qui declenche l'e-mail, sans dependre du script Klaviyo de la boutique
        return fetch(endpoint + 'events' + key, options({
          type: 'event',
          attributes: {
            properties: eventData,
            metric: { data: { type: 'metric', attributes: { name: 'Proteines Calculated' } } },
            profile: { data: { type: 'profile', attributes: { email: email, properties: profileData } } }
          }
        }));
      }).then(checked).then(function() {
        try {
          // Rattache le navigateur au profil, comme le calculateur d'IMC
          if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['identify', { '$email': email }]);
        } catch (err) {}
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'generate_lead', lead_source: 'calculateur_proteines', prot_langue: lang });
        } catch (err) {}
        // Le formulaire reste en place, fige : la confirmation remplace le bouton sans deplacer la page
        emailInput.readOnly = true;
        optin.disabled = true;
        toggle.disabled = true;
        submitBtn.hidden = true;
        done.hidden = false;
        done.focus();
      }).catch(function() {
        sending = false;
        submitBtn.disabled = false;
        fail(T.errSend);
      });
    });
  })();
})();